"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ServiceNow AI Toolkit
 * ServiceNow AI Toolkit API
 *
 * The version of the OpenAPI document:
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeApi = exports.MeApiFactory = exports.MeApiFp = exports.MeApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * MeApi - axios parameter creator
 * @export
 */
const MeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Check permission (action & resource) for your user or role
         * @param {string} action Expression (supporting wildcards) denoting the action(s) performed on the resource(s)
         * @param {string} resource URN-like expression (supporting wildcards) for matching resource(s)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeAllowedGet: (action_1, resource_1, ...args_1) => __awaiter(this, [action_1, resource_1, ...args_1], void 0, function* (action, resource, options = {}) {
            // verify required parameter 'action' is not null or undefined
            (0, common_1.assertParamExists)('v1MeAllowedGet', 'action', action);
            // verify required parameter 'resource' is not null or undefined
            (0, common_1.assertParamExists)('v1MeAllowedGet', 'resource', resource);
            const localVarPath = `/v1/me/allowed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }
            if (resource !== undefined) {
                localVarQueryParameter['resource'] = resource;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get apps for your user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeAppGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/me/app`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get your user/role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeGet: (human_1, ...args_1) => __awaiter(this, [human_1, ...args_1], void 0, function* (human, options = {}) {
            const localVarPath = `/v1/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs created by your user/role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/me/job`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get job occupation statistics for your user/role
         * @param {V1AccountJobOccupancyGetTypeParameter} [type] Get occupancy statistics by day, week, month, or year
         * @param {string} [from] date (YYYY-MM-DD)
         * @param {string} [to] date (YYYY-MM-DD)
         * @param {number} [noNull] When set to 1, the dates without data are omitted from the reply.
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobOccupancyGet: (type_1, from_1, to_1, noNull_1, limit_1, offset_1, order_1, ...args_1) => __awaiter(this, [type_1, from_1, to_1, noNull_1, limit_1, offset_1, order_1, ...args_1], void 0, function* (type, from, to, noNull, limit, offset, order, options = {}) {
            const localVarPath = `/v1/me/job_occupancy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (noNull !== undefined) {
                localVarQueryParameter['no_null'] = noNull;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs created by your user/role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobRunGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/me/job_run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a policy in your user/role
         * @param {string} policyId The ID or fullname of the policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyDelete: (policyId_1, ...args_1) => __awaiter(this, [policyId_1, ...args_1], void 0, function* (policyId, options = {}) {
            // verify required parameter 'policyId' is not null or undefined
            (0, common_1.assertParamExists)('v1MePolicyDelete', 'policyId', policyId);
            const localVarPath = `/v1/me/policy/{policy_id}`
                .replace(`{${"policy_id"}}`, encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get policies in your user/role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/me/policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Post a policy in your user/role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {PolicyPost} [policyPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyPost: (human_1, policyPost_1, ...args_1) => __awaiter(this, [human_1, policyPost_1, ...args_1], void 0, function* (human, policyPost, options = {}) {
            const localVarPath = `/v1/me/policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(policyPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update your user/role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {UserOrRolePost} [userOrRolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePut: (human_1, userOrRolePost_1, ...args_1) => __awaiter(this, [human_1, userOrRolePost_1, ...args_1], void 0, function* (human, userOrRolePost, options = {}) {
            const localVarPath = `/v1/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userOrRolePost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get terms of the organization of your user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeTermsGet: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/v1/me/terms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Set terms as readed for your user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeTermsPut: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/v1/me/terms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.MeApiAxiosParamCreator = MeApiAxiosParamCreator;
/**
 * MeApi - functional programming interface
 * @export
 */
const MeApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.MeApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Check permission (action & resource) for your user or role
         * @param {string} action Expression (supporting wildcards) denoting the action(s) performed on the resource(s)
         * @param {string} resource URN-like expression (supporting wildcards) for matching resource(s)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeAllowedGet(action, resource, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeAllowedGet(action, resource, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MeApi.v1MeAllowedGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get apps for your user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeAppGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeAppGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MeApi.v1MeAppGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get your user/role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeGet(human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeGet(human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MeApi.v1MeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs created by your user/role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeJobGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MeApi.v1MeJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get job occupation statistics for your user/role
         * @param {V1AccountJobOccupancyGetTypeParameter} [type] Get occupancy statistics by day, week, month, or year
         * @param {string} [from] date (YYYY-MM-DD)
         * @param {string} [to] date (YYYY-MM-DD)
         * @param {number} [noNull] When set to 1, the dates without data are omitted from the reply.
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobOccupancyGet(type, from, to, noNull, limit, offset, order, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeJobOccupancyGet(type, from, to, noNull, limit, offset, order, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MeApi.v1MeJobOccupancyGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs created by your user/role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobRunGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeJobRunGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MeApi.v1MeJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete a policy in your user/role
         * @param {string} policyId The ID or fullname of the policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyDelete(policyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MePolicyDelete(policyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MeApi.v1MePolicyDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get policies in your user/role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MePolicyGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MeApi.v1MePolicyGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Post a policy in your user/role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {PolicyPost} [policyPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyPost(human, policyPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MePolicyPost(human, policyPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MeApi.v1MePolicyPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update your user/role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {UserOrRolePost} [userOrRolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePut(human, userOrRolePost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MePut(human, userOrRolePost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MeApi.v1MePut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get terms of the organization of your user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeTermsGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeTermsGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MeApi.v1MeTermsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Set terms as readed for your user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeTermsPut(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeTermsPut(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MeApi.v1MeTermsPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.MeApiFp = MeApiFp;
/**
 * MeApi - factory interface
 * @export
 */
const MeApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.MeApiFp)(configuration);
    return {
        /**
         *
         * @summary Check permission (action & resource) for your user or role
         * @param {MeApiV1MeAllowedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeAllowedGet(requestParameters, options) {
            return localVarFp.v1MeAllowedGet(requestParameters.action, requestParameters.resource, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get apps for your user
         * @param {MeApiV1MeAppGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeAppGet(requestParameters = {}, options) {
            return localVarFp.v1MeAppGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get your user/role
         * @param {MeApiV1MeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeGet(requestParameters = {}, options) {
            return localVarFp.v1MeGet(requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs created by your user/role
         * @param {MeApiV1MeJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobGet(requestParameters = {}, options) {
            return localVarFp.v1MeJobGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get job occupation statistics for your user/role
         * @param {MeApiV1MeJobOccupancyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobOccupancyGet(requestParameters = {}, options) {
            return localVarFp.v1MeJobOccupancyGet(requestParameters.type, requestParameters.from, requestParameters.to, requestParameters.noNull, requestParameters.limit, requestParameters.offset, requestParameters.order, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs created by your user/role
         * @param {MeApiV1MeJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobRunGet(requestParameters = {}, options) {
            return localVarFp.v1MeJobRunGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a policy in your user/role
         * @param {MeApiV1MePolicyDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyDelete(requestParameters, options) {
            return localVarFp.v1MePolicyDelete(requestParameters.policyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get policies in your user/role
         * @param {MeApiV1MePolicyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyGet(requestParameters = {}, options) {
            return localVarFp.v1MePolicyGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post a policy in your user/role
         * @param {MeApiV1MePolicyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyPost(requestParameters = {}, options) {
            return localVarFp.v1MePolicyPost(requestParameters.human, requestParameters.policyPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update your user/role
         * @param {MeApiV1MePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePut(requestParameters = {}, options) {
            return localVarFp.v1MePut(requestParameters.human, requestParameters.userOrRolePost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get terms of the organization of your user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeTermsGet(options) {
            return localVarFp.v1MeTermsGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set terms as readed for your user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeTermsPut(options) {
            return localVarFp.v1MeTermsPut(options).then((request) => request(axios, basePath));
        },
    };
};
exports.MeApiFactory = MeApiFactory;
/**
 * MeApi - object-oriented interface
 * @export
 * @class MeApi
 * @extends {BaseAPI}
 */
class MeApi extends base_1.BaseAPI {
    /**
     *
     * @summary Check permission (action & resource) for your user or role
     * @param {MeApiV1MeAllowedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v1MeAllowedGet(requestParameters, options) {
        return (0, exports.MeApiFp)(this.configuration).v1MeAllowedGet(requestParameters.action, requestParameters.resource, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get apps for your user
     * @param {MeApiV1MeAppGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v1MeAppGet(requestParameters = {}, options) {
        return (0, exports.MeApiFp)(this.configuration).v1MeAppGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get your user/role
     * @param {MeApiV1MeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v1MeGet(requestParameters = {}, options) {
        return (0, exports.MeApiFp)(this.configuration).v1MeGet(requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs created by your user/role
     * @param {MeApiV1MeJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v1MeJobGet(requestParameters = {}, options) {
        return (0, exports.MeApiFp)(this.configuration).v1MeJobGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get job occupation statistics for your user/role
     * @param {MeApiV1MeJobOccupancyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v1MeJobOccupancyGet(requestParameters = {}, options) {
        return (0, exports.MeApiFp)(this.configuration).v1MeJobOccupancyGet(requestParameters.type, requestParameters.from, requestParameters.to, requestParameters.noNull, requestParameters.limit, requestParameters.offset, requestParameters.order, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs created by your user/role
     * @param {MeApiV1MeJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v1MeJobRunGet(requestParameters = {}, options) {
        return (0, exports.MeApiFp)(this.configuration).v1MeJobRunGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a policy in your user/role
     * @param {MeApiV1MePolicyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v1MePolicyDelete(requestParameters, options) {
        return (0, exports.MeApiFp)(this.configuration).v1MePolicyDelete(requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get policies in your user/role
     * @param {MeApiV1MePolicyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v1MePolicyGet(requestParameters = {}, options) {
        return (0, exports.MeApiFp)(this.configuration).v1MePolicyGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post a policy in your user/role
     * @param {MeApiV1MePolicyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v1MePolicyPost(requestParameters = {}, options) {
        return (0, exports.MeApiFp)(this.configuration).v1MePolicyPost(requestParameters.human, requestParameters.policyPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update your user/role
     * @param {MeApiV1MePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v1MePut(requestParameters = {}, options) {
        return (0, exports.MeApiFp)(this.configuration).v1MePut(requestParameters.human, requestParameters.userOrRolePost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get terms of the organization of your user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v1MeTermsGet(options) {
        return (0, exports.MeApiFp)(this.configuration).v1MeTermsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Set terms as readed for your user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v1MeTermsPut(options) {
        return (0, exports.MeApiFp)(this.configuration).v1MeTermsPut(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MeApi = MeApi;
